import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Seller_Legal_Status_Enum } from '@gql'
import React, { forwardRef } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type SellerLegalStatusSelectProps = {
  field: ControllerRenderProps<any>
  className?: string
}
export const SellerLegalStatusSelect = forwardRef<
  HTMLInputElement,
  SellerLegalStatusSelectProps
>(({ field, className }, ref) => {
  const { t } = useTranslation()
  return (
    <FormItem className={className}>
      <FormLabel>{t('SellerLegalStatusSelect.label')}</FormLabel>
      <Select onValueChange={field.onChange} value={field.value}>
        <FormControl>
          <SelectTrigger className="tw-w-full">
            <SelectValue
              ref={ref}
              placeholder={t('SellerLegalStatusSelect.placeholder')}
            />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {Object.values(Seller_Legal_Status_Enum).map((status) => (
            <SelectItem value={status} key={status}>
              {t(`SellerLegalStatusSelect.${status}`)}
            </SelectItem>
          ))}
        </SelectContent>
        <FormMessage />
      </Select>
    </FormItem>
  )
})

SellerLegalStatusSelect.displayName = 'SellerLegalStatusSelect'
